import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

class Header extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  render() {
    return (
      <div>
        <Helmet>
        </Helmet>
        {React.Children.only(this.props.children)}
      </div>
    );
  }
}
Header.propTypes = {
  children: PropTypes.element.isRequired,
};

export default Header;